import * as UserActions from './user.actions';
import moment from 'moment';

import {INITIAL_STATE, DEFAULT_DATE_FORMAT} from './user.state';

export const CurrentUserReducer = (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case UserActions.REQUEST_USER_SUCCESS: {
      //hack to fix show images for now , as images is an account feature that does not have premmision
      //so we well give for every one as the code worked before
      //this line should be removed when we respect account feature that does not need user permission
      payload.features.push({
        path: 'images'
      });

      payload.permissions = payload.features.map(u => u.path);

      // add moment localization
      const {
        claims: {
          data: {timezone: userTimezone, language: userLanguage}
        }
      } = payload;

      if (userTimezone) {
        moment.tz.setDefault(userTimezone);
      }

      if (userLanguage) {
        moment.tz.setDefault(userLanguage);
      }

      moment.locale(payload.claims.data.language);

      // Get locale data
      const localeData = moment.localeData();
      const localDateFormat = localeData.longDateFormat('L');
      let {dateFormat = localDateFormat || DEFAULT_DATE_FORMAT} = payload.claims.data;

      // don't clobber any existing claims
      payload.claims = {...payload.claims, ...state.claims};

      return {
        ...state,
        ...payload,
        dateFormat: dateFormat
      };
    }
    case UserActions.REQUEST_CLAIMS_SUCCESS: {
      //if user did not set his dateformat keep using state one
      let {dateFormat = state.dateFormat} = payload.data;
      return {
        ...state,
        claims: {
          ...state.claims,
          data: {...payload.data}
        },
        dateFormat: dateFormat
      };
    }
    case UserActions.RECEIVE_USER_CLAIMS:
      return {
        ...state,
        claims: {
          ...state.claims,
          ...payload
        }
      };
    case UserActions.REQUEST_USER_FAIL:
      return {
        ...state,
        error: payload
      };
    case UserActions.REQUEST_USER_ACCOUNTS_SUCCESS: {
      const {accounts, currentAccount, memberShips, accountNameLookup} = payload;

      return {
        ...state,
        switchableAccounts: accounts,
        memberShipCount: memberShips.length,
        currentAccount: currentAccount,
        accountNameLookup: accountNameLookup
      };
    }
    case UserActions.REQUEST_USER_ACCOUNTS_FAIL:
      return {
        ...state,
        accountsError: payload
      };
    case UserActions.REQUEST_DATAPOINTS_DESCRIPTORS_SUCCESS:
      return {
        ...state,
        datapointDescriptors: payload
      };
    default:
      return state;
  }
};
